import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import authService, { SESSION_EXPIRED } from '@/core/auth/services/auth-service';

export default function Auth0Page() {
  const { loginWithRedirect, getAccessTokenSilently, isLoading } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;

    authService.loginWithAuth0(getAccessTokenSilently).then(
      value => {
        console.log('We have an auth0 token, redirecting');
        const redirectPath = localStorage.getItem('redirectPath') || '/dashboard';
        localStorage.removeItem('redirectPath');
        navigate(redirectPath);
      },
      reason => {
        // If token is missing/expired, redirect to Auth0 with tracking params
        const utm_source = sessionStorage.getItem('utm_source') ?? undefined;
        const platform = 'MY_MNI';

        loginWithRedirect({
          authorizationParams: {
            utm_source,
            platform,
            ...(reason?.message === SESSION_EXPIRED && { prompt: 'login' }),
          },
        }).then(value => console.log(''));
      },
    );
    // eslint-disable-next-line
  }, [isLoading]);
  return <>Loading</>;
}
